import { NavLink, Outlet, useNavigate } from "react-router-dom";

import { useAuth } from "../services/auth-context";

const STUDIO_NAV_ITEMS = [
  {
    to: "/studio",
    label: "Dashboard",
    icon: "M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z",
    end: true,
  },
  {
    to: "/studio/invite",
    label: "Invita clienti",
    icon: "M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z",
    end: false,
  },
];

function NavIcon({ d }: { d: string }) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flexShrink: 0, opacity: 0.75 }}
    >
      <path d={d} />
    </svg>
  );
}

export function StudioShell() {
  const { tokens, logout } = useAuth();
  const navigate = useNavigate();
  const hasWorkspace = Boolean(tokens?.workspace_id);

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand-block">
          <div
            className="brand-logo"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
              color: "#fff",
              fontWeight: 800,
              fontSize: "0.85rem",
            }}
          >
            ST
          </div>
          <div>
            <h2>IncassaFlow</h2>
            <p>Dashboard Studio</p>
          </div>
        </div>

        {/* Toggle Studio ↔ App */}
        {hasWorkspace && (
          <div className="role-toggle">
            <button className="role-toggle-btn active" type="button">
              Studio
            </button>
            <button
              className="role-toggle-btn"
              type="button"
              onClick={() => navigate("/dashboard")}
            >
              App
            </button>
          </div>
        )}

        <nav className="sidebar-nav">
          {STUDIO_NAV_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
            >
              <NavIcon d={item.icon} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <button
          type="button"
          className="ghost-btn"
          onClick={logout}
          style={{ marginTop: "auto" }}
        >
          &larr; Esci
        </button>
      </aside>

      <main className="page-content" id="main-content">
        <Outlet />
      </main>
    </div>
  );
}
